import { render, staticRenderFns } from "./PageController.vue?vue&type=template&id=7cc72f9c"
import script from "./PageController.vue?vue&type=script&lang=js"
export * from "./PageController.vue?vue&type=script&lang=js"
import style0 from "./PageController.vue?vue&type=style&index=0&id=7cc72f9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports